import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import {Challenge, IChallengeMetadata} from "@/types/ChallengeType";
import posthog from '@/posthog';

@Module
export default class ChallengeModule extends VuexModule {
    errors = {};
    challenges = {} as Challenge;
    current_challenge = {} as Challenge;
    current_challenge_metadata = {} as IChallengeMetadata;

    /**
     * Get all challenges
     * @returns Challenges
     */
    get getChallenges(): Challenge {
        return this.challenges;
    }
    get getCurentChallenge(): Challenge {
        return this.current_challenge;
    }
    get getChallengesMetadata(): IChallengeMetadata {
        return this.current_challenge_metadata;
    }

    @Action
    async [Actions.GET_ALL_CHALLENGES]() {
        try {
            const response: any = await ApiService.get('/academy/challenges/list');
            this.context.commit(Mutations.SET_CHALLENGES, response.data.data);
            this.context.commit(Mutations.SET_CHALLENGES_METADATA, response.data.meta);
            posthog.capture('viewed_challenges', {});
        } catch (error) {
            this.context.commit(Mutations.SET_CHALLENGES, {});
            this.errors = error;

        }
    }

    @Action
    async [Actions.GET_FILTERED_CHALLENGES]({ type, dificulty, search, status, page, categories, is_freemium }: { type: string, dificulty: string, search: string, status: string, page: string, categories: [], is_freemium: boolean | null }) {
        const params: any = {
            type: type ? type : "default",
            dificulty: dificulty ? dificulty : "",
            progress: status ? status : "",
            search: search ?  search : "",
            categories: categories ? categories : []
        }

        if(is_freemium !== null && is_freemium !== undefined) {
            params.is_freemium = is_freemium ? "true" : "false";
        }

        if(page) {
            params["page"] = page;
        }
        const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');

        try {
            const response: any = await ApiService.get('/academy/challenges/list?'+queryString);
            this.context.commit(Mutations.SET_CHALLENGES, response.data.data);
            this.context.commit(Mutations.SET_CHALLENGES_METADATA, response.data.meta);
            posthog.capture('viewed_challenges', {
              filter_type: type,
              filter_difficulty: dificulty,
              filter_search: search,
              filter_status: status,
              filter_categories: categories,
              filter_is_freemium: is_freemium,
              page: page
            });
        } catch (error) {
            this.context.commit(Mutations.SET_CHALLENGES, {});
            this.errors = error;

        }
    }

    @Action
    async [Actions.GET_CHALLENGE](id: number) {

        try {
            const response: any = await ApiService.get('/academy/challenges/'+id);
           this.context.commit(Mutations.SET_CHALLENGES, response.data.data);
              posthog.capture('viewed_challenge', {
                challenge_id: id,
                challenge_name: response.data.data?.name,
                challenge_difficulty: response.data.data?.difficulty,
                is_freemium: response.data.data?.is_freemium,
                challenge_type: response.data.data?.type,
                percentage_solved: response.data.data?.percentage,
                points: response.data.data?.points,
                is_solved: response.data.data?.is_solved
            });

        } catch (error) {
            this.context.commit(Mutations.SET_CHALLENGES, {});
            this.errors = error;

        }

    }

    @Action
    async [Actions.GET_TOURNAMENT_CHALLENGES]({ tournament_id, page }: { tournament_id: number, page?: number }) {
        const params: any = {
            tournament_id: tournament_id
        }

        if (page) {
            params["page"] = page;
        }

        const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');

        try {
            const response: any = await ApiService.get('/academy/challenges/list?' + queryString);
            this.context.commit(Mutations.SET_CHALLENGES, response.data.data);
            this.context.commit(Mutations.SET_CHALLENGES_METADATA, response.data.meta);
            posthog.capture('viewed_tournament_challenges', {
                tournament_id: tournament_id,
                page: page
            });
        } catch (error) {
            this.context.commit(Mutations.SET_CHALLENGES, {});
            this.errors = error;
        }
    }

    @Mutation
    [Mutations.SET_CHALLENGE](challenge: Challenge) {
        this.current_challenge = challenge;
    }

    @Mutation
    [Mutations.SET_CHALLENGES](challenges: Challenge) {
        this.challenges = challenges;
    }

    @Mutation
    [Mutations.SET_CHALLENGES_METADATA](metadata) {
        this.current_challenge_metadata = metadata;
    }
}
